import { cn } from "@/lib/utils";

type Status = "draft" | "submitted" | "approved" | "rejected" | "open" | "closed" | "active" | "inactive";

interface StatusPillProps {
  status: Status;
  className?: string;
}

export function StatusPill({ status, className }: StatusPillProps) {
  const styles: Record<Status, string> = {
    draft: "bg-slate-100 text-slate-600 border-slate-200",
    submitted: "bg-blue-50 text-blue-600 border-blue-200",
    approved: "bg-emerald-50 text-emerald-600 border-emerald-200",
    rejected: "bg-red-50 text-red-600 border-red-200",
    open: "bg-emerald-50 text-emerald-600 border-emerald-200",
    closed: "bg-slate-100 text-slate-500 border-slate-200",
    active: "bg-emerald-50 text-emerald-600 border-emerald-200",
    inactive: "bg-slate-100 text-slate-500 border-slate-200",
  };

  return (
    <span className={cn(
      "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border uppercase tracking-wider",
      styles[status] || "bg-gray-100 text-gray-800",
      className
    )}>
      {status}
    </span>
  );
}
